import domReady from '../utils/domReady';

domReady.then(()=>{
    [...document.querySelectorAll('links-select')].forEach((element) => {
        element.querySelector('select').addEventListener('change', ({target:{value}}) => window.location.href=value);
    });
    [...document.querySelectorAll('links-select + image-cards')].forEach((element) => {
        element.addEventListener('click', event => {
            let {target} = event,
                link;
                
            if(!target.matches('basic-card')){
                target = target.closest('basic-card') || target;
            }
            link = (target.querySelector('footer > a') || document.createElement('a')).getAttribute('href');
            if(target.matches('basic-card, basic-card *') && link){
                event.preventDefault();
                window.location.href = link;
            }
        }, false);
    });
});
